import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import withLocalization from "../../../hoc/withLocalization";
import Select from "../../../elements/Select";

const AbsenceStatusesSelectWidgetMobx = inject('commonStore')(withLocalization(observer(class AbsenceStatusesSelectWidgetMobx extends Component {
    render() {
        const { value, disabled, t } = this.props;
        const { client } = this.props.commonStore?.config || {};
        const statuses = client?.data?.extendedRules?.absent_types || [];

        const options = statuses.map(({ code, name }) => ({
            label: t(name),
            value: code
        }));

        const currentSelect = options.find(opt => String(opt.value) === String(value)) || null;

        return (
            <Select
                options={options}
                value={currentSelect}
                isDisabled={disabled}
                onChange={selected => this.props.onChange(selected ? selected.value : null)}
                isClearable={false}
            />
        );
    }
})));

export const AbsenceStatusesSelectWidget = observer(class AbsenceStatusesSelectWidget extends Component {
    render() {
        return <AbsenceStatusesSelectWidgetMobx {...this.props} />;
    }
});

export const AbsenceStatusesSelectWidgetOnEdit = observer(class AbsenceStatusesSelectWidgetOnEdit extends Component {
    render() {
        return <AbsenceStatusesSelectWidgetMobx {...this.props} disabled />;
    }
});